// -------------- settings Page --------------
export const SETTINGS_FIELD_ERROR       = 'SETTINGS_FIELD_ERROR';
export const SETTINGS_FIELD_RESET_ERROR = 'SETTINGS_FIELD_RESET_ERROR';
export const SETTINGS_GET_ITEM          = 'SETTINGS_GET_ITEM';
export const SETTINGS_SET_ITEM          = 'SETTINGS_SET_ITEM';



// --------- settings Page ---------
export function settingsFieldError(field, fieldData = {}) {
    return { type: SETTINGS_FIELD_ERROR, fieldName: field, fieldData: fieldData }
}
export function settingsFieldResetError(field, fieldData = {}) {
    return { type: SETTINGS_FIELD_RESET_ERROR }
}
export function settingsSetItem(targetItem) {
    return { type: SETTINGS_SET_ITEM, data: targetItem }
}
export function settingsGetItem(targetItem) {
    return { type: SETTINGS_GET_ITEM, data: targetItem }
}

